<template>
  <div class="panel-body">
    <import-data :route="filterable.model" :json_fields="headers" :json_data="planos"></import-data>
    <div class="row">
      <div class="col-md-12">
        <filterable ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th class="col-md-1">{{$t('words.options')}}</th>
              <th>Tipo</th>
              <th>{{$t('attributes.name')}}</th>
              <th>Valor</th>
              <th>Usuários</th>
              <th>Documentos</th>
              <th>Ativo?</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button type="button" class="btn btn-default btn-sm dropdown-toggle"
                  v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" @click="detailsObject(item)">
                    <i class="fa fa-eye"></i>
                    {{$t('words.details') }}
                  </a>
                  <router-link class="dropdown-item" :to="{ name: `planoEdit`, params: { id: item.id}}">
                    <i class="fa fa-pencil"></i>
                    {{$t('words.edit')}}
                  </router-link>
                  <a class="dropdown-item" @click="deleteData(item.id, item.nome, 'plano')">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                    {{$t('words.delete')}}
                  </a>
                </div>
              </div>
            </td>
            <td>
              <span v-if="item.ck_tipo == 'D'" class="text-red"><i class="fa fa-check-circle"></i> Trial</span>
              <span v-if="item.ck_tipo == 'P'" class="text-green"><i class="fa fa-check-circle"></i> Padrão</span>
              <span v-if="item.ck_tipo == 'N'" class="text-orange"><i class="fa fa-warning"></i> Negociavel</span>
            </td>
            <td>{{item.nome}}</td>
            <td>{{formatMoney(item.valor)}}</td>
            <td>{{item.usuarios}}</td>
            <td>{{item.documentos}}</td>
            <td>
              <span v-if="item.ativo" class="text-green"><i class="fa fa-check-circle"></i> Sim</span>
              <span v-else class="text-red"><i class="fa fa-times-circle"></i> Não</span>
            </td>
          </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterable: {
          url: '/api/planos',
          storeAction: 'setPlanos',
          storeName: 'plano.data',
          model: 'plano',
          showLinkDeleted: false
        },
        objectDetails: {},
        description: 'descricao',
        headers: {
          'Nome': 'nome',
          'Descrição': 'descricao'
        }
      };
    },
    computed: {
      planos() {
        return this.$store.state.plano.data;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'planos') {
          this.prepareComponent();
        }
      }
    }
  };
</script>